import Hero from '~/components/hero';
import RecruitmentBenefits from '../__components/recruitment-benefits';
import RecruitmentHighlights from '../__components/recruitment-highlights';
import RecruitmentOpenings from '../__components/recruitment-openings';
import { serverCallAPI } from '~/services/serverCallAPI';
import { IProvincesResponse } from '~/types/types';
import React from 'react';
import { Await } from 'react-router';
import { Route } from './+types/_index';
import SectionChild from '~/components/SectionChild';
import Heading2 from '../__components/heading2';
import { LayoutLoading } from '~/components/global-loading';

export async function loader({request}:Route.LoaderArgs) {
  const provincesWithStats = serverCallAPI<IProvincesResponse>(
    "/api/job/provinces-with-stats"
  );
  return {
    provincesWithStats,
  };
}

function Recruitment({ loaderData }: Route.ComponentProps) {
  let { provincesWithStats } = loaderData;

  return (
    <div>
      <Hero
        image="/image/tuyen-dung/982ef5bc9b85337f84011294e490954bc3486b07.jpg"
        showLinear
        title="Tuyển dụng"
      />

      <RecruitmentBenefits />
      <RecruitmentHighlights />
      <SectionChild className="py-[100px]">
        <div className="max-w-2xl pb-10">
          <Heading2>Khám phá sự nghiệp với KLAND</Heading2>
          <p className="mt-3 text-base text-gray-600">
            Chúng tôi luôn tìm kiếm những tài năng xuất sắc để cùng định hình
            tương lai của KLand. Dưới đây là các vị trí chúng tôi đang tuyển.
          </p>
        </div>
        <React.Suspense fallback={<LayoutLoading/>}>
          <Await
            resolve={provincesWithStats}
            errorElement={<div className='text-center'>Chưa có thông tin tuyển dụng</div>}
          >
            {(value) => <RecruitmentOpenings data={value} />}
          </Await>
        </React.Suspense>
      </SectionChild>
    </div>
  );
}

export default Recruitment;

